import React from 'react';
import { motion } from 'framer-motion';
import { scrollToOffer } from '../utils/scrollToOffer';
export function HeroSection() {
  return <section className="relative md:pt-0 md:pb-24 overflow-hidden bg-white pt-0 pb-[30px]" data-id="element-89">
      {' '}
      <div aria-hidden="true" className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none" data-id="element-90">
        <div className="absolute -top-[10%] left-1/2 -translate-x-1/2 w-[80%] h-[60%] rounded-full bg-[#f5c842]/10 blur-3xl" data-id="element-91" />
      </div>
      <div className="container mx-auto px-4 relative z-10 max-w-[1100px] text-center" data-id="element-92">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="inline-flex items-center gap-2 px-5 py-2 mb-4 md:mb-8 rounded-full border border-[#1a2e5a]/10 bg-[#f8f8f8] text-[#1a2e5a] font-bold tracking-[0.1em] uppercase text-[10px] md:text-[12px]" data-id="element-93">
          ✨ EL SISTEMA COMPLETO PARA LA DOCENTE DE NIVEL INICIAL
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="font-heading md:text-5xl mb-3 md:mb-6 max-w-3xl mx-auto font-extrabold text-[#1a2e5a] text-[24px]" data-id="element-94">
          Planificaciones, actividades y recursos{' '}
          <span className="inline-block px-3 py-0.5 rounded-lg -rotate-1 text-[#FF6B35] bg-[#00000]" data-id="element-95">
            listos para usar.
          </span>
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mb-4 md:mb-10 max-w-3xl mx-auto" data-id="element-96">
          <img src="https://cdn.magicpatterns.com/uploads/o8R5NGVeuN22rCf1ojgb15/mockup-final.webp" alt="La Agenda del Nivel Inicial" width={800} height={800} loading="eager" fetchPriority="high" decoding="async" className="w-full h-auto object-contain drop-shadow-2xl max-h-[34vh] md:max-h-none mx-auto" data-id="element-97" />
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="md:text-xl text-slate-600 mb-5 md:mb-10 max-w-2xl mx-auto text-[14px] md:text-[16px] font-medium" data-id="element-98">
          El sistema completo de planificaciones y recursos para ahorrar tiempo,
          organizarte mejor y resolver tu trabajo docente desde el primer día.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="flex flex-col items-center" data-id="element-99">
          <motion.a href="#comprar" onClick={scrollToOffer} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="flex items-center justify-center gap-3 w-full sm:w-auto bg-[#f5c842] hover:bg-[#e5b832] text-[#1a2e5a] font-extrabold px-10 py-4 md:py-5 rounded-xl shadow-lg shadow-[#f5c842]/30 transition-colors mb-4 md:mb-6 text-[18px] md:text-[20px]" data-id="element-100">
            🚀 ¡QUIERO MI MEGAPACK!
          </motion.a>

          <div className="flex flex-wrap justify-center gap-4 text-sm font-semibold text-slate-600" data-id="element-101">
            <span data-id="element-102">
              <span aria-hidden="true" data-id="element-103">⭐⭐⭐⭐⭐</span> 4.9/5 — Avalado por
              docentes de toda Argentina
            </span>
            <span aria-hidden="true" className="hidden sm:inline text-slate-300" data-id="element-104">
              |
            </span>
            <span data-id="element-105">
              <span aria-hidden="true" data-id="element-106">🛡️</span> Acceso Inmediato y Garantía de
              7 Días
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}